// 事件的绑定（兼容）
// W3C addEventListener
// IE attachEvent
export const bindEvent = (obj, type, fn, bubble = false) => {
    !Array.isArray(obj) && (obj = [obj])
    obj.forEach(element => {
        // 2.	开始判断浏览器
        if (typeof element.addEventListener != 'undefined') {
            element.addEventListener(type, fn, bubble) // W3C
        } else if (typeof element.attachEvent != 'undefined') {
            element.attachEvent('on'+type, fn) // IE
        } else {
            element["on" + type] = fn
        }
    })
    return obj
}

export default {
    bindEvent
}


// WEBPACK FOOTER //
// ./public/uitls/helper.js